import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
export type Page = 'home' | 'about' | 'contact';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  return <div className="min-h-screen flex flex-col font-body bg-cream text-charcoal" data-id="element-0">
      <Navbar currentPage={currentPage} setPage={setCurrentPage} data-id="element-1" />

      <main className="flex-grow flex flex-col" data-id="element-2">
        {currentPage === 'home' && <HomePage setPage={setCurrentPage} data-id="element-3" />}
        {currentPage === 'about' && <AboutPage setPage={setCurrentPage} data-id="element-4" />}
        {currentPage === 'contact' && <ContactPage data-id="element-5" />}
      </main>

      <Footer setPage={setCurrentPage} data-id="element-6" />
    </div>;
}